import React from "react";
import { StarIcon } from "lucide-react";
import { Section, SectionHeading } from "../Section";
import { testimonials } from "../../data/landing";
export function TestimonialsSection() {
  return <Section tone="white" cta="I want to use the system" data-id="element-269" data-mp="1rv62pbfzahay">
      <SectionHeading eyebrow="What professionals are saying" title="Rated 4.9/5 by medical professionals" data-id="element-270" data-mp="1rtl7rkpr4wck" />
      <div className="mt-4 flex justify-center gap-1" aria-label="4.9 out of 5 stars" data-id="element-271" data-mp="1muql27onynn6">
        {Array.from({
        length: 5
      }).map((_, i) => <StarIcon key={i} className="h-6 w-6 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-272" data-mp="1duv8byfgmkl1" data-mpi={i} />)}
      </div>

      <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-273" data-mp="18xbtoxeuo5sk">
        {testimonials.map((t, i) => <figure key={t.name} className={`flex flex-col rounded-3xl border border-line bg-cream p-6 md:p-7 ${i === 0 ? "md:col-span-2" : ""}`} data-id="element-274" data-mp="13za0hjnpmq3d" data-mpi={i}>
            <div className="flex gap-0.5" aria-hidden="true" data-id="element-275" data-mp="2ycjd3kbjyrpu">
              {Array.from({
            length: 5
          }).map((_, s) => <StarIcon key={s} className="h-4 w-4 fill-amber-400 text-amber-400" data-id="element-276" data-mp="1tbzun3y3v92j" data-mpi={s} />)}
            </div>
            <blockquote className="mt-3 flex-1" data-id="element-277" data-mp="1jbpiznrpy9ph">
              <p className="font-serif text-xl font-bold leading-snug text-ink md:text-2xl" data-id="element-278" data-mp="1jd0mrnl5zhgl">“{t.headline}”</p>
              <p className="mt-2 text-[16px] leading-relaxed text-inkSoft" data-id="element-279" data-mp="1oasn95zvkbwe">“{t.quote}”</p>
            </blockquote>
            <figcaption className="mt-5 flex items-center gap-3 border-t border-line pt-5" data-id="element-280" data-mp="2c2h9c4m3s44w">
              <img src={t.image} alt={t.name} className="h-14 w-14 shrink-0 rounded-full object-cover ring-2 ring-white" loading="lazy" data-id="element-281" data-mp="2h1amtx1e3v52" />
              <div data-id="element-282" data-mp="2uyz999b3vac8">
                <p className="font-bold text-ink" data-id="element-283" data-mp="2uyh39kyn5hr4">{t.name}</p>
                <p className="text-sm text-inkSoft" data-id="element-284" data-mp="2uwwb21zsuawf">{t.role}</p>
              </div>
            </figcaption>
          </figure>)}
      </div>
    </Section>;
}